<footer class="app-footer">
  <!-- <div class="footer-content">
    <p class="copyright"> -->
      © {{ currentYear }} Duke Energy Corporation. All rights reserved. | 
      <span class="app-info">HRM (Health & Risk Management) v{{ version }}</span>
    <!-- </p>
  </div> -->
</footer>
